import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/icon_logo.png'


const _hoisted_1 = { id: "home_page" }
const _hoisted_2 = { class: "hero-part" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "text-side" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode(" We create "),
  /*#__PURE__*/_createElementVNode("span", null, "unique & efficient"),
  /*#__PURE__*/_createTextVNode(" digital solutions ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " We are providing solutions for all kinds of businesses, from small to enterprise organizations, individuals as well as the general public. ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Checkout our Products")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "img-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo Icon"
  })
], -1)
const _hoisted_9 = { class: "hero-footer" }
const _hoisted_10 = { class: "socials" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-double-down" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"about-us\" id=\"about_us\"><div class=\"content\"><h1 class=\"page-title\">Our story</h1><ul class=\"list-unstyled\"><li><h4>Mthatha</h4><span>Born</span></li><li><h4>6 Years</h4><span>Work Experience</span></li><li><h4>20+</h4><span>Happy Customers</span></li></ul><div class=\"details\"><h1 class=\"main-title\"> High-caliber software development and technology provider </h1><p> mY++ (Pty) Ltd is a technology innovations company headquartered in Johannesburg. mY++&#39;s primary objective is to enhance customers&#39; experience and maximize their productivity by improving existing tools and inventing new technologies. We are providing solutions for all kinds of businesses, from small to enterprise organizations, individuals as well as the general public. </p><p> According to (Datareportal, 2021), there were 38.19 million internet users in South Africa in January 2021. The number of internet users in South Africa increased by 1.7 million (+4.5%) between 2020 and 2021. Internet penetration in South Africa stood at 64.0% in January 2021. mY++ is embracing the 4th industrial revolution, we are striving to form a significant part in this revolution while also bridging the gap, pulling the societies that are behind with technology, ensuring they are up with the technology growth and usage so as to benefit from the advantages that it brings. </p></div></div></div>", 1)
const _hoisted_14 = {
  class: "service",
  id: "our_services"
}
const _hoisted_15 = { class: "content" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "header-part" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, [
    /*#__PURE__*/_createTextVNode("Services "),
    /*#__PURE__*/_createElementVNode("span", null, "we offer")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " We are providing solutions for all kinds of businesses, from small to enterprise organizations, individuals as well as the general public. ")
], -1)
const _hoisted_17 = { class: "service-list" }
const _hoisted_18 = { class: "row gy-5" }
const _hoisted_19 = {
  class: "projects",
  id: "our_projects"
}
const _hoisted_20 = { class: "content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "header-part" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, [
    /*#__PURE__*/_createTextVNode("Our "),
    /*#__PURE__*/_createElementVNode("span", null, "projects")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " We have a wide range of projects that we are proud to be working on. You can request a demo of any our listed projects. ")
], -1)
const _hoisted_22 = { class: "projects-list" }
const _hoisted_23 = { class: "row gx-5 gy-5 justify-content-center" }
const _hoisted_24 = {
  class: "contact-us",
  id: "contact_us"
}
const _hoisted_25 = { class: "container" }
const _hoisted_26 = { class: "row gx-3 gy-5" }
const _hoisted_27 = { class: "col-sm-5" }
const _hoisted_28 = { class: "text-side" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<h1>Let&#39;s make it happen</h1><ul class=\"list-unstyled contact-details\"><li><a href=\"tel:+27780687445\"><i class=\"fa fa-phone\"></i> 078 068 7445</a></li><li><a href=\"mailto:info@myplusplus.com\"><i class=\"fa fa-envelope\"></i> info@myplusplus.com</a></li></ul>", 2)
const _hoisted_31 = { class: "socials" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "col-sm-7" }
const _hoisted_34 = { class: "contact-form" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h4", null, "Leave us a message", -1)
const _hoisted_36 = ["onSubmit"]
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Hello, I am ", -1)
const _hoisted_39 = { class: "form-group mb-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, "I am looking for help with a", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { class: "form-check form-check-inline" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "presentation"
}, "Presentation", -1)
const _hoisted_44 = { class: "form-check form-check-inline" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "cloud_computing"
}, "Cloud Computing", -1)
const _hoisted_46 = { class: "form-check form-check-inline" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "development"
}, "Software Development", -1)
const _hoisted_48 = { class: "form-check form-check-inline" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "maintenance"
}, "Maintenance and Support", -1)
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-sm-6" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Please contact me at", -1)
const _hoisted_54 = { class: "col-sm-6" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Or my phone number", -1)
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "message" }, "More details about request", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "main-btn"
}, "Submit", -1)

import { socialLinks } from "@/data/socialLinks.json";
import { services } from "@/data/services.json";
import { projects } from "@/data/projects.json";
import Service from "@/components/Service.vue";
import Project from "@/components/Project.vue";
import { ref } from "vue";
import axios from "axios";

// Your reactive form fields

export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const name = ref("");
const help = ref("");
const email = ref("");
const phone = ref("");
const message = ref("");

const EMAIL_ENDPOINT =
  "https://kdtaj5dootrjfpaqowomhua5ce0okvek.lambda-url.af-south-1.on.aws/";

// Submit handler
const handleSubmit = async () => {
  const subject = `New contact form submission from ${name.value}`;
  const body = `
    <h2>Contact Form Submission</h2>
    <p><strong>Name:</strong> ${name.value}</p>
    <p><strong>Help with:</strong> ${help.value}</p>
    <p><strong>Email:</strong> ${email.value}</p>
    <p><strong>Phone:</strong> ${phone.value}</p>
    <p><strong>Message:</strong><br>${message.value}</p>
  `;
  const payload = {
    toAddresses: ["fezekileplaatyi@myplusplus.com"],
    subject,
    body,
    fromAddress: "noreply@myplusplus.com",
  };

  try {
    await axios.post(EMAIL_ENDPOINT, payload);
    alert("Message sent successfully!");
    name.value = "";
    help.value = "";
    email.value = "";
    phone.value = "";
    message.value = "";
  } catch (error) {
    console.error("Error sending email:", error);
    alert("Failed to send message.");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _createVNode(_component_router_link, {
            to: "/#our_projects",
            class: "main-btn"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialLinks), (socialLink) => {
              return (_openBlock(), _createElementBlock("a", {
                key: socialLink.id,
                href: socialLink.url,
                target: "_blank",
                rel: "noopener noreferrer"
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(`fa ${socialLink.icon}`)
                }, null, 2)
              ], 8, _hoisted_11))
            }), 128))
          ]),
          _hoisted_12,
          _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " mY Plus Plus Inc.", 1)
        ])
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(services), (service) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-sm-4",
                key: service.id
              }, [
                _createVNode(Service, { service: service }, null, 8, ["service"])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projects), (project) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-sm-10",
                key: project.id
              }, [
                _createVNode(Project, { project: project }, null, 8, ["project"])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("div", _hoisted_31, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialLinks), (socialLink) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: socialLink.id,
                    href: socialLink.url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(`fa ${socialLink.icon}`)
                    }, null, 2)
                  ], 8, _hoisted_32))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("form", {
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                    type: "text",
                    id: "name",
                    placeholder: "Enter your name",
                    required: ""
                  }, null, 512), [
                    [_vModelText, name.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((help).value = $event)),
                      class: "form-check-input",
                      type: "radio",
                      id: "presentation",
                      value: "Presentation"
                    }, null, 512), [
                      [_vModelRadio, help.value]
                    ]),
                    _hoisted_43
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((help).value = $event)),
                      class: "form-check-input",
                      type: "radio",
                      id: "cloud_computing",
                      value: "Cloud Computing"
                    }, null, 512), [
                      [_vModelRadio, help.value]
                    ]),
                    _hoisted_45
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((help).value = $event)),
                      class: "form-check-input",
                      type: "radio",
                      id: "development",
                      value: "Software Development"
                    }, null, 512), [
                      [_vModelRadio, help.value]
                    ]),
                    _hoisted_47
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((help).value = $event)),
                      class: "form-check-input",
                      type: "radio",
                      id: "maintenance",
                      value: "Maintenance and Support"
                    }, null, 512), [
                      [_vModelRadio, help.value]
                    ]),
                    _hoisted_49
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((email).value = $event)),
                        type: "email",
                        id: "email",
                        placeholder: "Email",
                        required: ""
                      }, null, 512), [
                        [_vModelText, email.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((phone).value = $event)),
                        type: "text",
                        id: "phone",
                        placeholder: "Phone"
                      }, null, 512), [
                        [_vModelText, phone.value]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((message).value = $event)),
                    id: "message",
                    rows: "3",
                    placeholder: "Message"
                  }, null, 512), [
                    [_vModelText, message.value]
                  ])
                ]),
                _hoisted_58
              ], 40, _hoisted_36)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})